export type TRANSLATION_ENTRY = 'summary'
export type TRANSLATION_LANGUAGES = 'en' | 'es' | 'fr'

type StoreState = {
  summary: string
  show_captions: string
  hide_captions: string
  seek_backward: string
  seek_forward: string
  mute: string
  unmute: string
  settings: string
  airplay: string
  fullscreen: string
  pip: string
  take_aways: string
  live_not_started: string
  live_ended: string
  loading: string
  chromecast: string
  start_chromecast: string
  stop_chromecast: string
  chromecasting: string
  play: string
  pause: string
  replay: string
  quality: string
  speed: string
  report: string
  manifest_load_error: string
  media_error: string
  network_error: string
  other_error: string
}

const translations: Record<
  keyof StoreState,
  Record<TRANSLATION_LANGUAGES, string>
> = {
  summary: {
    en: 'Summary',
    es: 'Resumen',
    fr: 'Résumé',
  },
  show_captions: {
    en: 'Show captions (c)',
    es: 'Mostrar subtítulos (c)',
    fr: 'Afficher les sous-titres (c)',
  },
  hide_captions: {
    en: 'Hide captions (c)',
    es: 'Ocultar subtítulos (c)',
    fr: 'Masquer les sous-titres (c)',
  },
  seek_backward: {
    en: 'Seek backward (←)',
    es: 'Retroceder (←)',
    fr: 'Reculer (←)',
  },
  seek_forward: {
    en: 'Seek forward (→)',
    es: 'Avanzar (→)',
    fr: 'Avancer (→)',
  },
  mute: {
    en: 'Mute (m)',
    es: 'Silenciar (m)',
    fr: 'Couper le son (m)',
  },
  unmute: {
    en: 'Unmute (m)',
    es: 'Activar sonido (m)',
    fr: 'Activer le son (m)',
  },
  settings: {
    en: 'Settings (s)',
    es: 'Configuración (s)',
    fr: 'Paramètres (s)',
  },
  fullscreen: {
    en: 'Fullscreen (f)',
    es: 'Pantalla completa (f)',
    fr: 'Plein écran (f)',
  },
  pip: {
    en: 'Picture-in-picture (p)',
    es: 'Imagen en imagen (p)',
    fr: 'Image dans l&apos;image (p)',
  },
  take_aways: {
    en: 'Take-aways',
    es: 'Conclusiones',
    fr: 'Conclusions',
  },
  live_not_started: {
    en: 'Live stream has not started yet. Please wait a moment.',
    es: 'La transmisión en vivo aún no ha comenzado. Por favor, espere un momento.',
    fr: 'La diffusion en direct n&apos;a pas encore commencé. Veuillez patienter un instant.',
  },
  live_ended: {
    en: 'Live stream is over.',
    es: 'La transmisión en vivo es terminado.',
    fr: 'La diffusion en direct est terminée.',
  },
  loading: {
    en: 'loading',
    es: 'La transmisión en vivo es terminado.',
    fr: 'cargando',
  },
  airplay: {
    en: 'AirPlay',
    es: 'AirPlay',
    fr: 'AirPlay',
  },
  chromecast: {
    en: 'Chromecast',
    es: 'Chromecast',
    fr: 'Chromecast',
  },
  start_chromecast: {
    en: 'Chromecast',
    es: 'Chromecast',
    fr: 'Chromecast',
  },
  stop_chromecast: {
    en: 'Stop broadcasting',
    es: 'Detener la difusión',
    fr: 'Arrêter la diffusion',
  },
  chromecasting: {
    en: 'Playing on',
    es: 'Emitido on',
    fr: 'Lecture sur ',
  },
  play: {
    en: 'Play',
    es: 'Play',
    fr: 'Play (space)',
  },
  pause: {
    en: 'Pause',
    es: 'Pause',
    fr: 'Pause',
  },
  replay: {
    en: 'Replay',
    es: 'Replay',
    fr: 'Replay',
  },
  quality: {
    en: 'Quality',
    es: 'Calidad',
    fr: 'Qualité',
  },
  speed: {
    en: 'Speed',
    es: 'Velocidad',
    fr: 'Vitesse',
  },
  report: {
    en: 'Report',
    es: 'Reportar',
    fr: 'Signaler',
  },
  manifest_load_error: {
    en: 'This video is not available',
    es: 'Este vídeo no está disponible',
    fr: "Cette vidéo n'est pas disponible",
  },
  media_error: {
    en: 'Invalid media',
    es: 'Media no válido',
    fr: 'Media invalide',
  },
  network_error: {
    en: 'Network error',
    es: 'Error de red',
    fr: 'Erreur de réseau',
  },
  other_error: {
    en: 'An error occurred',
    es: 'Ha ocurrido un error',
    fr: "Une erreur s'est produite",
  },
}

const defaults: StoreState = Object.keys(translations).reduce((acc, key) => {
  acc[key as keyof StoreState] = translations[key as keyof StoreState].en
  return acc
}, {} as StoreState)

const state = $state(defaults)

let lastLanguage = $state('en')

// $effect(() => {
//   if (componentAttributesStore.state.uiLanguage !== lastLanguage) {
//     lastLanguage = componentAttributesStore.state.uiLanguage.split('-')[0]
//     if (['en', 'es', 'fr'].includes(lastLanguage)) {
//       for (const key in translations) {
//         state[key as keyof StoreState] =
//           translations[key as keyof StoreState][
//             lastLanguage as TRANSLATION_LANGUAGES
//           ]
//       }
//     }
//   }
// })

const get = (key: keyof StoreState, language?: string) => {
  return (
    translations[key][language as TRANSLATION_LANGUAGES] ||
    translations[key][lastLanguage as TRANSLATION_LANGUAGES] ||
    ''
  )
}

export default {
  state,
  defaults,
  get,
}
